module.exports = __webpack_public_path__ + "static/img/banner.db4cf2e7.png";